import React from 'react';
import { Phone, Wind, Wrench, Thermometer, Snowflake, Zap, Shield, Award } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-20 bg-[#0D1233]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block bg-[#0066FF]/20 text-[#00D9FF] px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4">
            Our Services
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Complete HVAC Solutions
          </h2>
          <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto">
            From emergency repairs to preventative maintenance – we handle all your heating, cooling, and refrigeration needs
          </p>
        </div>

        {/* Residential Services */}
        <div className="mb-16">
          <h3 className="text-xl font-bold text-white mb-8 flex items-center">
            <div className="w-10 h-10 bg-gradient-to-br from-[#0066FF] to-[#00D9FF] rounded-lg flex items-center justify-center mr-3">
              <Wind className="w-5 h-5 text-white" />
            </div>
            Residential Services
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { icon: <Wind className="w-7 h-7" />, title: 'AC Servicing', desc: 'Regular maintenance keeps your system efficient' },
              { icon: <Wrench className="w-7 h-7" />, title: 'AC Repairs', desc: 'Expert fault finding and fast fixes' },
              { icon: <Thermometer className="w-7 h-7" />, title: 'Heating Systems', desc: 'Heat pump installs, repairs & servicing' },
              { icon: <Zap className="w-7 h-7" />, title: 'Split Installations', desc: 'Professional AC & heat pump installations' }
            ].map((service, i) => (
              <Card key={i} className="bg-white/5 border border-white/10 hover:border-[#00D9FF]/30 hover:bg-white/[0.08] transition-all duration-300 group">
                <CardContent className="p-6">
                  <div className="text-[#00D9FF] mb-3 group-hover:scale-110 transition-transform">{service.icon}</div>
                  <h4 className="text-base font-bold text-white mb-2">{service.title}</h4>
                  <p className="text-gray-400 text-sm">{service.desc}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Commercial Services */}
        <div>
          <h3 className="text-xl font-bold text-white mb-8 flex items-center">
            <div className="w-10 h-10 bg-gradient-to-br from-[#0A0E27] to-[#111640] rounded-lg flex items-center justify-center mr-3 border border-white/10">
              <Award className="w-5 h-5 text-[#00D9FF]" />
            </div>
            Commercial HVAC Solutions
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { icon: <Shield className="w-7 h-7" />, title: 'Maintenance Contracts', desc: 'Scheduled preventative servicing plans' },
              { icon: <Snowflake className="w-7 h-7" />, title: 'Cold Room Service', desc: 'Commercial refrigeration specialists' },
              { icon: <Wrench className="w-7 h-7" />, title: 'System Management', desc: 'Full HVAC system oversight' },
              { icon: <Zap className="w-7 h-7" />, title: 'Priority Support', desc: 'Dedicated response for businesses' }
            ].map((service, i) => (
              <Card key={i} className="bg-white/[0.03] border border-white/[0.06] hover:border-[#0066FF]/30 hover:bg-white/[0.06] transition-all duration-300 group">
                <CardContent className="p-6">
                  <div className="text-[#0066FF] mb-3 group-hover:scale-110 transition-transform">{service.icon}</div>
                  <h4 className="text-base font-bold text-white mb-2">{service.title}</h4>
                  <p className="text-gray-400 text-sm">{service.desc}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Button size="lg" className="bg-gradient-to-r from-[#0066FF] to-[#00D9FF] hover:from-[#0052CC] hover:to-[#00B8D4] text-white text-lg px-8 py-6 font-bold shadow-lg shadow-blue-500/25">
            <a href="tel:0644505026" className="flex items-center space-x-2">
              <Phone className="w-5 h-5" />
              <span>Call for Any Service: 064 450 5026</span>
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};
